import { useState } from 'react';
// import { Redirect, useHistory } from 'react-router-dom';

import { usePost } from 'hooks';
import { login } from 'services/api';

import { FormContainer, Logo, H2, Form, Alert } from './styled';
import { Modal } from 'components/common';

const Login = () => {
  const [form] = useState({ email: '', password: '' });
  const [{ error }, postLogin] = usePost({ url: login });
  // const { setToken, user } = useAuth();
  const [showInfo, setShowInfo] = useState(false);
  // const { push } = useHistory();

  // useEffect(() => {
  //   if (res) {
  //     setToken(res.token);
  //   }
  // }, [res, setToken]);

  // if (user) {
  //   return <Redirect to='/' />;
  // }

  // const handleChange = (key) => (value) =>
  //   setForm((s) => ({ ...s, [key]: value }));

  // const handleReset = () => push('/resetPassword');

  // const handleSignup = () => push('/signup');

  const handleSubmit = (e) => {
    e.preventDefault();
    postLogin(form);
  };

  return (
    <FormContainer>
      <Logo icon='logo' />
      <H2>Welcome</H2>
      {/* <H5>Log in to your account</H5> */}
      <Form onSubmit={handleSubmit}>
        <Alert type='warning'>
          Please note PAW is currently down for maintenance until approximately
          9am.
          <br />
          <br />
          <span
            style={{ color: 'blue', cursor: 'pointer' }}
            onClick={() => setShowInfo(true)}
          >
            Click here to learn more.
          </span>
        </Alert>
        <Modal show={showInfo} onClose={() => setShowInfo(false)}>
          <h3>PAW is getting an upgrade!</h3>
          <div>
            <br />
            We're excited to let you know that PAW is about to receive a
            significant upgrade.
            <br />
            <br />
            This update is a complete rewrite under the hood, designed to
            deliver improved performance and a smoother, faster experience -
            especially on mobile devices.
            <br />
            <br />
            <h4>What to expect</h4>
            To carry out this upgrade, we will need to temporarily restrict
            access to the website. During this period you will not be able to
            access PAW Rescue Manager.
            <br />
            <br />
            <h4>Your data is safe</h4>
            All of your data is secure and will remain fully intact throughout
            the upgrade process. We'll work to keep downtime as brief as
            possible, so you can pick up where you left off in no time.
            <br />
            <br />
            Thank you for your patience as we improve PAW.
          </div>
        </Modal>
        {/* <Input
          disabled={loading}
          icon='email'
          placeholder='Email'
          type='email'
          value={form.email}
          onChange={handleChange('email')}
        />
        <Input
          disabled={loading}
          icon='lock'
          placeholder='Password'
          type='password'
          value={form.password}
          onChange={handleChange('password')}
        />
        <Button
          disabled={loading}
          fullWidth
          size='large'
          onClick={handleSubmit}
        >
          Log In
        </Button>
        <Button
          disabled={loading}
          type='secondary'
          fullWidth
          size='large'
          onClick={handleReset}
        >
          Reset Password
        </Button>
        <Button
          disabled={loading}
          type='secondary'
          fullWidth
          size='large'
          onClick={handleSignup}
        >
          New Rescue Signup
        </Button> */}
      </Form>
      {error && (
        <Alert type='error'>
          Unable to log in, are your credentials correct?
        </Alert>
      )}
    </FormContainer>
  );
};

export default Login;
